import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[mapToolbar]' })
export class MapToolbarDirective {
    constructor(public tpl: TemplateRef<any>) {}
}
